import { FC } from 'react'
import { FiCheck } from 'react-icons/fi'
import { GoClock } from 'react-icons/go'
import { AiOutlineLoading3Quarters } from 'react-icons/ai'

import CustomText from '../../CustomText'

type TrackItemProps = {
  label: string
  description: string
  tertiary?: string
  count: string
  isActive: boolean
  handleClick: () => void
  disableButton: boolean
  passedStepper?: boolean
  isFirstItem: boolean
  isLastItem: boolean
}

export const TrackItem: FC<TrackItemProps> = ({
  label,
  description,
  tertiary,
  count,
  isActive,
  handleClick,
  disableButton = false,
  passedStepper = false,
  isFirstItem,
  isLastItem
}: TrackItemProps) => {
  return (
    <div
      className={`w-auto h-auto flex flex-row gap-x-[20px] items-center gap-y-4`}
      onClick={handleClick}
    >
      <div className="w-auto h-full flex flex-col items-center">
        <div
          className={`w-[1.2px] h-[20px] ${isActive ? 'bg-[#ffbe00]' : ''} ${passedStepper ? 'bg-[#5cbdeb]' : ''} ${!passedStepper && !isActive ? 'bg-[#ded8b7]' : ''} ${isFirstItem ? 'bg-transparent' : ''}`}
        ></div>
        <div
          className={`w-[40px] h-[40px] flex flex-col justify-center items-center rounded-full ${isActive ? 'bg-[#ffbe00]' : ''} ${passedStepper ? 'bg-[#5cbdeb]' : ''} ${!passedStepper && !isActive ? 'bg-[#FCFBF6] border-solid border-[1.5px] border-[#ded8b7]' : ''}`}
        >
          {!isActive && !passedStepper && (
            <GoClock
              className="w-[20px] h-[20px] tSM2:w-[16px] tSM2:h-[16px] mMD:w-[14px] mMD:h-[14px]"
              color="black"
            />
          )}

          {isActive && !passedStepper && (
            <AiOutlineLoading3Quarters
              className="w-[20px] h-[20px] tSM2:w-[16px] tSM2:h-[16px] mMD:w-[14px] mMD:h-[14px]"
              color="white"
            />
          )}

          {!isActive && passedStepper && (
            <FiCheck
              className="w-[20px] h-[20px] tSM2:w-[16px] tSM2:h-[16px] mMD:w-[14px] mMD:h-[14px]"
              color="white"
            />
          )}
        </div>
        <div
          className={`w-[1.2px] h-[20px] ${isActive ? 'bg-[#ffbe00]' : ''} ${passedStepper ? 'bg-[#5cbdeb]' : ''} ${!passedStepper && !isActive ? 'bg-[#ded8b7]' : ''} ${isLastItem ? 'bg-transparent' : ''}`}
        ></div>
      </div>

      <div className="w-full h-auto flex flex-col gap-y-[2px]">
        <div className="w-full h-auto flex flex-row justify-between">
          <CustomText
            textLabel={label}
            fontWeight={`font-semibold`}
            fontSize="text-[16px]"
            fontColor={`text-black`}
          />

          {isActive && (
            <div
              className={`w-auto h-auto flex flex-col justify-center items-center rounded-full px-[10px] py-[4px] ${isActive ? 'bg-[#f5e5b1] border-solid border-[1.5px] border-[#ffbe00]' : ''} ${passedStepper ? 'bg-[#b4ebcd] border-solid border-[1.5px] border-[#5cbdeb]' : ''} ${!passedStepper && !isActive ? 'bg-[#ffffff] border-solid border-[1.5px] border-[#cdcdcd]' : ''}`}
            >
              <CustomText
                textLabel={'Underway'}
                fontWeight={`font-light`}
                fontSize="text-[12px]"
                fontColor={`text-black`}
              />
            </div>
          )}

          {passedStepper && (
            <div
              className={`w-auto h-auto flex flex-col justify-center items-center rounded-full px-[10px] py-[4px] ${isActive ? 'bg-[#f5e5b1] border-solid border-[1.5px] border-[#ffbe00]' : ''} ${passedStepper ? 'bg-[#5cbdeb] border-solid border-[1.5px] border-[#5cbdeb]' : ''} ${!passedStepper && !isActive ? 'bg-[#ffffff] border-solid border-[1.5px] border-[#cdcdcd]' : ''}`}
            >
              <CustomText
                textLabel={'Done'}
                fontWeight={`font-light`}
                fontSize="text-[12px]"
                fontColor={`text-black`}
              />
            </div>
          )}

          {!isActive && !passedStepper && (
            <div
              className={`w-auto h-auto flex flex-col justify-center items-center rounded-full px-[10px] py-[4px] ${isActive ? 'bg-[#f5e5b1] border-solid border-[1.5px] border-[#ffbe00]' : ''} ${passedStepper ? 'bg-[#b4ebcd] border-solid border-[1.5px] border-[#5cbdeb]' : ''} ${!passedStepper && !isActive ? 'bg-[#FCFBF6] border-solid border-[1.5px] border-[#ded8b7]' : ''}`}
            >
              <CustomText
                textLabel={'Up next'}
                fontWeight={`font-light`}
                fontSize="text-[12px]"
                fontColor={`text-black`}
              />
            </div>
          )}
        </div>
        {tertiary && (
          <CustomText
            textLabel={tertiary}
            fontWeight={`font-light`}
            fontSize="text-[14px]"
            fontColor={`text-black`}
          />
        )}
        <CustomText
          textLabel={description}
          fontWeight={`font-regular`}
          fontSize="text-[16px]"
          fontColor={`text-black`}
        />
      </div>
    </div>
  )
}

export default TrackItem
